import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, tap } from 'rxjs';
import { DialogService } from '../../../dialog/services/dialog.service';
import { OrganisationService } from '../../../organisation/organisation/services/organisation.service';
import { PagedResults } from '../../Model/pagedresults';
import { ReviewRequestDTO } from '../../Model/reviewRequestDTO';
import { RequestService } from '../../services/requests.services';
import { RequestDetailDialogComponent } from '../../request-detail-dialog/request-detail-dialog.component';

@Component({
  selector: 'app-all-request-list',
  templateUrl: './all-request-list.component.html',
  styleUrls: ['./all-request-list.component.css']
})
export class AllRequestListComponent implements OnInit, OnDestroy{
  requests: ReviewRequestDTO[] = [];
  isListloading = false;
  dataSource: any;
  displayedColumns: string[] = ['id', 'title', 'status', 'deadline'];
  currentOrganisation: any;
  organisationSubscriber!: Subscription;
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  paginationSubscription?: Subscription;
  dialogBoxSubscription?: Subscription;
  isError = false;
  errorMessage!: string;
  totalRecords?: number;
  isEmptyList = false;

  constructor(private readonly dialog: MatDialog,
    private readonly requestService: RequestService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly organisationService: OrganisationService,
    private readonly dialogService: DialogService){   
  }   

  getRequests() {
    this.isListloading = true;
    this.requestService.getallrequests(
      this.paginator?.pageSize ?? 10,
      this.paginator?.pageIndex ?? 0).subscribe({
        next: (response: PagedResults) => {
          this.requests = response.records;
          this.totalRecords = response.totalRecords;
          this.isEmptyList = this.totalRecords == null;
        },
      error: (err: any) => {
        this.isError = true;
        this.errorMessage = err.error;
        this.isListloading = false;
      },
        complete: () => { this.isListloading = false; this.isError = false; }
    });
  }

  ngOnInit() {
    this.organisationSubscriber = this.organisationService.organisationEmitter.subscribe({
      next: (value: string) => {
        if (value === '') { this.currentOrganisation = this.organisationService.getLocalStorageItem("CurrentOrganisation") }
        else { this.currentOrganisation = value; }
      }
    });
    console.log(this.currentOrganisation);
    this.getRequests();   
  }

  onRequestNaviagte(requestId: number) {
    const requestDialogRef = this.dialog.open(RequestDetailDialogComponent, {
      data: { id: requestId },
      width: '100%',
      height:'100%',
      maxWidth:'100vw',
    });
    this.dialogBoxSubscription = requestDialogRef.afterClosed().subscribe({
      next: (result: any) => {
        this.router.navigate(['/allrequests'], { relativeTo: this.route });
      }
    });
  }
  ngAfterViewInit(): void {
    this.paginationSubscription = this.paginator?.page.pipe(tap(() => this.getRequests())).subscribe();
  }

  ngOnDestroy(): void {
    this.organisationSubscriber.unsubscribe();
    this.paginationSubscription?.unsubscribe();
    this.dialogBoxSubscription?.unsubscribe();
  }
  onRequestNaviagteNewPage(requestId:number){
    const url = this.router.createUrlTree([`/request/detail/${requestId}`], { relativeTo: this.route }).toString();
    window.open(url, '_blank');
  }
}
